import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { GlobalFunctionService } from '@app/system/services/global-function.service';
import { LocaleService } from '@app/system/services/locale.service';

export interface RequestCard {
	thumbnail?: string;
	userName?: string;
	title?: string;
	description?: string;
	nominatedUserThumbnail?: string;
	nominatedUserName?: string;
	nominatedUserCount?: number;
	date?: string;
	actions?: Array<{
		caption: string,
		key: string,
		classes: string | Array<string>
	}>;
}

@Component({
	selector: 'app-request-card',
	templateUrl: './request-card.component.html',
	styleUrls: ['./request-card.component.scss']
})
export class RequestCardComponent implements OnInit {

	@Input() type: 'horizontal' | 'vertical' = 'horizontal';
	@Input() data: RequestCard;
	@Output() detail = new EventEmitter();
	@Output() profile = new EventEmitter();
	@Output() nominatedUserProfile = new EventEmitter();
	@Output() nominatedUsers = new EventEmitter();
	@Output() action: any = new EventEmitter();

	constructor(
		public locale: LocaleService,
		public gfService: GlobalFunctionService
	) { }

	ngOnInit(): void {
	}

	info(data) {
		if (navigator.onLine) {
			this.detail.emit(data);
		}
	}

	profileInfo(data) {
		if (navigator.onLine) {
			this.profile.emit(data);
		}
	}

	nominatedUserProfileInfo(data) {
		if (navigator.onLine) {
			this.nominatedUserProfile.emit(data);
		}
	}

	nominatedUsersInfo(data) {
		if (navigator.onLine) {
			this.nominatedUsers.emit(data);
		}
	}

	actionInfo(action) {
		if (navigator.onLine) {
			this.action.emit(action);
		}
	}

}
